import { __ } from '@wordpress/i18n';
import PreviewCard from '../preview/PreviewCard';
import './CardPreview.css';

const CardPreview = ({ sections, variant = 'enhanced' }) => (
  <div className="hvnly--builder---api_property__builder__right-panel">
    <h2 className="hvnly--builder---api_property__builder__section-title">{__('Property Card Preview', 'havenlytics')}</h2>
    <div className="hvnly--builder---api_property__builder___enhanced_card_preview_container">
      <div className="hvnly--builder---api_property__builder___enhanced_card_preview">
        <PreviewCard 
          sections={sections} 
          variant={variant}
        />
      </div>
    </div>
  </div>
);

export default CardPreview;